import React from "react";
import { register } from "../services/api";
import * as Dialog from "@radix-ui/react-dialog";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import {
  setLogged,
  setUserData,
  setUserType,
} from "../store/reducers/listingReducer";
import { useNavigate, useParams } from "react-router-dom";
import { config } from "../config";
import { FormikInput } from "./ui/FormikInput";
import { ErrorMessage, Field, FieldProps, Form, Formik } from "formik";
import { countryOptions } from "../helpers/countryList";

interface IProps {
  isOpen: boolean;
  close: () => void;
}

export const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cookies = new Cookies();
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [isInvite, setIsInvite] = React.useState<boolean>(false);

  const logged = useSelector((state: any) => state.listingReducer.logged);

  let { token } = useParams();

  React.useEffect(() => {
    if (token && token !== "" && token !== undefined && !logged) {
      setIsInvite(true);
    } else {
      setIsInvite(false);
    }
  }, [token]);

  async function doRegister(val: any) {
    setErrorMessage("");
    let params: any = { ...val };
    if (isInvite) {
      delete params.email;
      delete params.team_name;
    }

    if (isInvite && !logged) {
      params["token"] = token;
    }
    let data = await register(params);
    if (data.data.success === true) {
      cookies.set("listings-app-login", true);
      localStorage.setItem("listings-app-login", "true");
      localStorage.setItem("listings-app-user-type", data.data.data.user_type);
      localStorage.setItem("listings-app-api-token", data.data.data.api_token);
      // props.close();
      dispatch(setLogged(true));
      dispatch(setUserType(data.data.data.user_type));
      dispatch(setUserData(data.data.data));
      // isCommercial
      navigate("/");
    } else if (data.data.success === false) {
      setErrorMessage(data.data.message);
      dispatch(setLogged(false));
      dispatch(setUserData(null));
    } else {
      setErrorMessage("Invalid Credentials");
      dispatch(setLogged(false));
      dispatch(setUserData(null));
    }
  }

  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Enter valid email")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
    c_password: Yup.string()
      .required("Please retype the password")
      .oneOf([Yup.ref("password")], "Passwords doesn't match"),
    team_name: Yup.string()
      .max(150, "Maximum no of characters should be 150")
      .matches(
        /^[A-Za-z0-9 ]+$/,
        "Team Name can only have alphabets, numbers and spaces"
      ),
    country: Yup.string().required("Select a country code"),
    phone: Yup.number().required("Phone number is required"),
  });

  //console.log(!isInvite )

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-gray-800 bg-opacity-60 fixed inset-0 z-40" />
        <Dialog.Content
          style={{ transform: "translate(-50%, -50%)" }}
          className="fixed left-1/2 top-1/2 bg-white p-6 z-40 min-w-[30rem]"
        >
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              c_password: "",
              team_name: "",
              email: "",
              password: "",
              country: "",
              phone: "",
              sms: false,
            }}
            onSubmit={async (val: any) => {
              console.log({ val });
              await doRegister({
                ...val,
                phone: `${val.country}${val.phone}`,
                sms: val.sms ? 1 : 0,
                notification_frequency: "every_10_listings",
              });
            }}
            validationSchema={validationSchema}
          >
            <Form>
              <div className="flex flex-col gap-y-3">
                <FormikInput
                  containerClassName="flex flex-col gap-y-2"
                  label="First Name"
                  name="first_name"
                />

                <FormikInput
                  containerClassName="flex flex-col gap-y-2"
                  label="Last Name"
                  name="last_name"
                />

                <FormikInput
                  containerClassName="flex flex-col gap-y-2"
                  label="Email"
                  name="email"
                  type="email"
                />
                {!isInvite && (
                  <FormikInput
                    containerClassName="flex flex-col gap-y-2"
                    label="Team Name"
                    name="team_name"
                    type="text"
                  />
                )}

                <FormikInput
                  containerClassName="flex flex-col gap-y-2"
                  label="Password"
                  name="password"
                  type="password"
                />

                <FormikInput
                  containerClassName="flex flex-col gap-y-2"
                  label="Confirm Password"
                  name="c_password"
                  type="password"
                />
                <div className="flex gap-x-4 flex-1">
                  <div className="flex flex-col gap-y-2">
                    <label
                      htmlFor="state"
                      className="text-sm font-medium text-gray-700"
                    >
                      Country
                    </label>
                    <Field
                      name="country"
                      as="select"
                      className="border px-4 py-2 outline-none w-full"
                    >
                      <option className="p-2" disabled value="">
                        Select country
                      </option>
                      {countryOptions.map((itm) => (
                        <option
                          value={itm.value}
                          key={"register-country-" + itm.value}
                        >
                          {itm.label}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="country">
                      {(msg) => (
                        <div className="text-xs text-red-500 mt-2">{msg}</div>
                      )}
                    </ErrorMessage>
                  </div>
                  <FormikInput
                    containerClassName="flex flex-col gap-y-2 w-2/3"
                    label="Phone"
                    name="phone"
                    type="number"
                  />
                </div>
                <Field name="sms">
                  {({ field }: FieldProps<any>) => (
                    <div className="flex items-center gap-x-4 mt-2">
                      <input
                        className="border w-4 h-4"
                        type="checkbox"
                        id="sms"
                        {...field}
                      />
                      <label
                        className="font-medium text-sm text-gray-700"
                        htmlFor="sms"
                      >
                        By checking this box, you agree to receive SMS
                        notifications about new properties in your subscribed
                        areas. Standard messaging rates may apply. You can opt
                        out anytime by texting STOP. Your privacy is important
                        to us, your information will not be shared.
                      </label>
                    </div>
                  )}
                </Field>
              </div>

              {errorMessage ? (
                <div className="p-3 bg-red-400 text-white mt-4">
                  {errorMessage}
                </div>
              ) : null}

              <div className="mt-4 flex w-full justify-end gap-x-4">
                {/* <button
                  className="px-4 py-2 border"
                  onClick={}
                  type="button"
                >
                  Close
                </button> */}
                <button
                  className="px-4 py-2 bg-primary text-white"
                  type="submit"
                >
                  Register
                </button>
              </div>
            </Form>
          </Formik>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
export default Register;
